import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { EntityTable } from '@/components/table/entity-table';
import { Link } from '@tanstack/react-router';

import { Badge } from '@/components/ui/badge';
import { formatPlainDate } from '@airreading/common';
import { ScheduledClassItem } from '@airreading/common/data';

const columnHelper = createColumnHelper<ScheduledClassItem>();

const scheduledClassesTableColumns = [
  columnHelper.accessor('classTimes', {
    id: 'classTimes',
    header: 'Class times (CT)',
    cell: ({ getValue }) => {
      const classTimes = getValue();
      return (
        <Badge variant="outline" className="font-normal mr-2 mb-2">
          {classTimes}
        </Badge>
      );
    },
  }),

  columnHelper.accessor('startPlainDate', {
    id: 'startPlainDate',
    header: 'Start date',
    cell: ({ getValue }) => {
      return <div>{formatPlainDate(getValue())}</div>;
    },
  }),

  columnHelper.accessor('endPlainDate', {
    id: 'endPlainDate',
    header: 'End date',
    cell: ({ getValue }) => {
      return <div>{formatPlainDate(getValue())}</div>;
    },
  }),

  columnHelper.accessor('sessionsLeft', {
    id: 'sessionsLeft',
    header: 'Sessions left',
    cell: ({ getValue }) => {
      return <div>{getValue()}</div>;
    },
  }),

  columnHelper.accessor((row) => row, {
    id: 'classId',
    header: 'Class ID',
    cell: ({ getValue }) => {
      const { schoolId, studentGroupId } = getValue();
      return (
        <Link
          to="/orgs/schools/$schoolId/classes/$classId"
          params={{ schoolId, classId: studentGroupId }}
          className="p-0 h-auto text-blue-600 hover:text-blue-800 underline"
        >
          {studentGroupId}
        </Link>
      );
    },
  }),
];

export const ScheduledClassesTable = ({ scheduledClasses }: { scheduledClasses: ScheduledClassItem[] }) => {
  const table = useReactTable({
    data: scheduledClasses,
    columns: scheduledClassesTableColumns,
    getRowId: (row) => row.classTimes,
    getCoreRowModel: getCoreRowModel(),
    enableSorting: false,
  });

  return (
    <EntityTable
      table={table}
      isLoading={false}
      hasError={false}
      emptyState="No scheduled classes found"
      errorState={null}
      emptyStateClassName="translate-y-0"
    />
  );
};
